module.exports = __webpack_public_path__ + "img/第5章_3-2_水牢畫圖_發光.jpg";